import React from 'react';
import api from '~/services/api';
import { Label, Input, TextArea } from '~/componentes/CustomForm';

import ShowConfirmacao from '~/utils/ShowConfirmacao';
import { Container } from './styles';
import CustomScrollBar from '~/componentes/CustomScrollBar';
import { Materialize } from '~/styles/materializeGrid';
import { SLModalFooter } from '~/pages/Sistema/componentes/SistemaList';

function EditContent({ mountedData }) {
  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    ShowConfirmacao(
      async () => {
        let response;

        response = await api.put(
          '/signed/empresa/administracao/configuracao',
          {
            ...data,
            id: mountedData.id,
          },
        );

        if (response?.status === 200) {
          closeReload && closeReload();
        }
        return response;
      },
      {
        errorModal: {
          defaultMessage: `Ocorreu um erro ao atualizar esse Item, por favor, tente novamente mais tarde.`,
        },
        message: `Tem certeza que deseja atualizar esse Item?`,
        successModal: `Item atualizado com sucesso!`,
      },
    );
  }

  return (
    <Container onSubmit={handleSubmit}>
      <CustomScrollBar fixScrollMargin autoHeightMin="62vh" autoHeightMax="62vh">
        <Materialize className="padding-form">
          <div className="row header">
            <p className="h-titulo">Edite o Item</p>
            <p className="h-descricao">Preencha as informações e salve</p>
          </div>
          <div className="row">
            <Label title="Título *" className="col s12 m12 l12">
              <Input name="titulo" defaultValue={mountedData?.titulo} />
            </Label>
          </div>
          <div className="row">
            <Label title="Descrição: " className="col s12 m12 l12">
              <TextArea
                name="descricao"
                defaultValue={mountedData?.descricao}
              />
            </Label>
          </div>
          <div className="row">
            <Label title="Valor *" className="col s12 m12 l12">
              <Input name="valor" defaultValue={mountedData?.valor} />
            </Label>
          </div>
        </Materialize>
      </CustomScrollBar>
      <SLModalFooter />
    </Container>
  );
}

export default EditContent;
